import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";

import Button from "components/CustomButton/CustomButton.jsx";
import Parse from 'parse';
import logo from './../../assets/img/logo-blanco.svg';
import CancelButton from './../Components/Presentation/CancelButton/CancelButton';
import PrimaryButton from './../Components/Presentation/PrimaryButton/PrimaryButton';



class LoginPage extends Component {
  
  constructor(props){
    super(props);
    this.state={
      username: '',
      password: '',
      loginError: null,
      isRestorePassword:false,
      restoreEmail: "",
      isRestoreError:false,
      restorePasswordError:"",
      restorePasswordSuccess:""
    };
  }

  handleUsername = (evt)=>{
    this.setState({ username: evt.target.value});
  }

  handlePassword = (evt)=>{
    this.setState({ password: evt.target.value});
  }

  handleRestoreEmail = (evt) => {
    this.setState({restoreEmail: evt.target.value});
  }

  validateEmail = (email)=>{
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  userLogin = ()=>{
    let password = this.state.password.trim();
    let email = this.state.username.toLowerCase();
    if (this.validateEmail(email)){
      if(password !== ""){
        Parse.User.logIn(this.state.username, this.state.password).then((user)=>{
          this.props.history.push('/dashboard');
        }).catch((error)=>{
          console.log(error.code);
          if(error.code === 101){
            this.setState({ loginError: 'Correo electrónico o contraseña invalidos.'})
          }else if(error.code === 201){
            this.setState({ loginError: `Contraseña es requerida.`})
          }else{
            this.setState({ loginError: error.message});
          }
        });
      }else{
        this.setState({ loginError: "Contraseña es requerida."});
      }
    }else{
      this.setState({ loginError: "Correo electrónico invalido."});
    }
  }

  registerUser = () => {
    this.props.history.push('/pages/register-page');
  }

  handleBtnRestorePassword = () => {
    this.setState({isRestorePassword:true});
  }

  returnToLogin = () => {
    this.setState({isRestorePassword:false});
  }

  restorePasswordRequest = async () => {
    const {restoreEmail} = this.state;
    if(restoreEmail === ""){
      this.setState({
        isRestoreError: true,
        restorePasswordError: "El email es obligatorio"
      });
      return;
    }
    
    if(!this.validateEmail(restoreEmail)){
      this.setState({
        isRestoreError: true,
        restorePasswordError: "No es un email válido"
      });
      return;
    }
    
    //Modo back4app
    Parse.User.requestPasswordReset(restoreEmail)
    .then(() => {
      this.setState({restorePasswordSuccess: "Enviamos un mensaje a tu email, por favor leelo y sigue el proceso de restauración de password."})
    })
    .catch((error) => {
      this.setState(
        {
          restorePasswordSuccess: "Ocurrio un error, por favor verica tus datos."
        }
      );
    });
        

  }

  render() {
    const {isRestorePassword} = this.state;
    if(!isRestorePassword){
      //Login
      return (
        <Grid>
          <Row>
            <div className="vertical-separator-64px"></div>
            <Col md={4} lg={4} sm={4}>
                <img src={logo} className="image-fluid logo-login"/>
            </Col>
          </Row>
          <div className="vertical-separator-50px"></div>
          <Row>
            <Col md={4} mdOffset={0} lg={4} sm={8} smOffset={2}>
              <form>
                <Card
                  hidden={this.state.cardHidden}
                  textCenter
                  title="Iniciar sesión"
                  content={
                    <Row>
                      <Col md={12}>
                        <div>
                          <FormGroup>
                            <ControlLabel>Correo Electrónico</ControlLabel>
                            <FormControl 
                              placeholder="Correo Electrónico" 
                              type="email" 
                              value={this.state.username}
                              onChange={this.handleUsername}/>
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Contraseña</ControlLabel>
                            <FormControl
                              placeholder="Contraseña"
                              type="password" 
                              value={this.state.password}
                              onChange={this.handlePassword}/>
                          </FormGroup>
                          {this.state.loginError}
                        </div>
                      </Col>
                      <Col md={12}  className="text-center">
                          <Button simple wd
                            onClick={this.handleBtnRestorePassword}
                          >Recuperar contraseña</Button>
                      </Col>
                    </Row>
                  }
                  legend={
                    <Row>
                      <Col md={5} sm={5} smOffset={1} mdOffset={1}>
                        <CancelButton 
                          text="Crear cuenta"
                          onClick={this.registerUser}>
                        </CancelButton>
                      </Col>

                      <Col md={5} sm={5}>
                        <PrimaryButton 
                          text="Iniciar Sesión"
                          onClick={this.userLogin}>
                        </PrimaryButton>
                      </Col>
                    </Row>
                  }
                  ftTextCenter
                />
              </form>
            </Col>
          </Row>
        </Grid>
      );
    }

    //Recuperar contraseña
    return (
      <Grid>
        <Row>
          <div className="vertical-separator-64px"></div>
          <Col md={4} sm={4}>
              <img src={logo} className="image-fluid logo-login"/>
          </Col>
        </Row>
        <div className="vertical-separator-50px"></div>

        <Row>
          <Col md={4} mdOffset={0} sm={8} smOffset={2} >
            <form>
              <Card
                hidden={this.state.cardHidden}
                textCenter
                title="Recuperar contraseña"
                content={
                  <Row>
                    <Col md={12} >
                      <div>
                        <FormGroup>
                          <ControlLabel>Correo Electrónico</ControlLabel>
                          <FormControl 
                            placeholder="Correo Electrónico" 
                            type="email" 
                            value={this.state.restoreEmail}
                            onChange={this.handleRestoreEmail}/>
                        </FormGroup>
                        {this.state.restorePasswordError}
                        {this.state.restorePasswordSuccess}
                      </div>
                    </Col>
                  </Row>
                }
                legend={
                  <Row>
                    <Col md={6} mdOffset={0} sm={5} smOffset={1}>
                      <CancelButton 
                        text="Regresar"
                        onClick={this.returnToLogin}>
                      </CancelButton>
                    </Col>

                    <Col md={6} sm={5}>
                      <PrimaryButton 
                        text="Recuperar"
                        onClick={this.restorePasswordRequest}>
                      </PrimaryButton>
                    </Col>
                  </Row>
                }
                ftTextCenter
              />
            </form>
          </Col>
        </Row>
      </Grid>
    );

  }
}

export default LoginPage;


// WEBPACK FOOTER //
// ./src/views/Pages/LoginPage.jsx